// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".waiter-send-message-history-tab .history-period .title[data-v-357aa18f]{font-weight:700}.waiter-send-message-history-tab .history-period .history-option[data-v-357aa18f]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
